<template>
	<div class="not-found-container">
		<div class="not-found-content">
			<img class="not-found-image" src="@/assets/images/img404.png" />
			<div class="info-box">
				<p class="title">抱歉！页面无法访问......</p>
				<div class="subtitle">
                    <p>可能因为：</p>
                    <p>网址有错误 〉请检查地址是否完整或存在多余字符</p>
                    <p>网址已失效 〉可能页面已删除，活动已下线等</p>
                </div>
				<p class="desc">你可以通过以下方式继续访问：</p>
				<div class="btn-group">
					<div class="btn btn-primary" @click="goHome">访问首页</div>
					<div class="btn btn-outline" @click="goBack">返回上一步</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'NotFound',
	methods: {
		goHome() {
			this.$router.push({ name: 'Index' });
		},
		goBack() {
			this.$router.go(-1);
		}
	}
};
</script>

<style lang="scss" scoped>
.not-found-container {
	width: 100vw;
	min-height: 100vh;
	background: #f6f7fa;
	display: flex;
	justify-content: center;
	align-items: center;

	.not-found-content {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 80px;
		padding: 40px;

        .not-found-image {
            width: 530px;
            height: 370px;
        }

		.info-box {
			display: flex;
			flex-direction: column;

			.title {
				font-weight: 400;
                font-size: 30px;
                line-height: 45px;
                color: #000000;
                text-align: center;
                font-style: normal;
                text-transform: none;
			}

			.subtitle {
                margin-top: 8rpx;
				font-weight: 400;
                font-size: 14px;
                color: #666666;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                text-transform: none;
			}

			.desc {
                margin-top: 26px;
				font-weight: 400;
                font-size: 16px;
                color: #333333;
                line-height: 28px;
                text-align: left;
                font-style: normal;
                text-transform: none;
			}

			.btn-group {
				display: flex;
				gap: 16px;
                margin-top: 16px;

				.btn {
					width: 120px;
					height: 40px;
					line-height: 40px;
					text-align: center;
					border-radius: 8px;
					font-size: 16px;
					cursor: pointer;
					transition: all 0.3s ease;

					&.btn-primary {
						background: #FF5967;
						color: #ffffff;

						&:hover {
							background: #e8324d;
						}
					}

					&.btn-outline {
						background: #ffffff;
						color: #FF5967;
						border: 1px solid #FF5967;

						&:hover {
							background: #fff5f6;
						}
					}
				}
			}
		}
	}
}

@media (max-width: 900px) {
	.not-found-container {
		.not-found-content {
			flex-direction: column;
			gap: 40px;

			.illustration-box {
				width: 280px;
				height: 280px;
			}

			.info-box {
				align-items: center;
				text-align: center;

				.title {
					font-size: 32px;
				}

				.btn-group {
					justify-content: center;
				}
			}
		}
	}
}
</style>